import React, { Fragment } from "react"
import { useKeenSlider } from "keen-slider/react"
import(/* webpackPrefetch: true */ "keen-slider/keen-slider.min.css")
import FoundationVariables from "../../Styles/Fondprodukter/variables/_foundation.scss"
import useParseCssList from "../Hooks/useParseCssList"
import useWindowSize from "../Hooks/useWindowSize"

const breakpoints = useParseCssList(FoundationVariables.breakpoints);

export default function ProductSlider(props) {
    const [currentSlide, setCurrentSlide] = React.useState(0)
    const [slidesPerView, setSlidesPerView] = React.useState(4)
    const [windowWidth] = useWindowSize()
    const [sliderRef, slider] = useKeenSlider({
        slidesPerView: slidesPerView,
        loop: false,
        slideChanged(s) {
          setCurrentSlide(s.details().relativeSlide)
        },
    })

    const getBreakpoint = name => {
        return parseInt(breakpoints[name].replace("px", ""))
    }

    React.useEffect(() => {
        if(windowWidth >= getBreakpoint("medium-large") && windowWidth < getBreakpoint("large")) {
            setSlidesPerView(3.1)
        }else if(windowWidth > 500 && windowWidth < getBreakpoint("medium-large")) {
            setSlidesPerView(2.1)
        }else if(windowWidth <= 500) {
            setSlidesPerView(1.2)
        }else{
            setSlidesPerView(4)
        }
    }, [windowWidth])

    var getSlides = () => {
        return props.children.map((child, i) => {
            return <div className="keen-slider__slide product-card column" itemType="http://schema.org/Product" dangerouslySetInnerHTML={{__html: child.innerHTML}} key={i}></div>
        })
    }

    const prevSlide = e => {
        e.stopPropagation()
        slider.prev()
    }

    const nextSlide = e => {
        e.stopPropagation()
        slider.next()
    }

    return <div className="row keen-slider-wrapper keen-slider-wrapper--show-overflow">
        <div className="keen-slider" ref={sliderRef}>
            {getSlides()}
        </div>
        {slider && <>
            <div className="keen-slider__arrow keen-slider__arrow--left" onClick={prevSlide} hidden={currentSlide == 0}>
                <i className="icon icon-chevron-left"></i>
            </div>
            <div className="keen-slider__arrow keen-slider__arrow--right" onClick={nextSlide} hidden={currentSlide >= slider.details().size - Math.floor(slidesPerView)}>
                <i className="icon icon-chevron-right"></i>
            </div>
        </>}
    </div>
}